var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXWalletIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 186,
    viewBox: "0 0 185 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.29 76.5102L145.89 23.4702C148.91 20.4802 146.75 15.4102 142.46 15.4102H121.91L92.72 44.2002L92.3 76.5202L92.29 76.5102Z",
    fill: "#B2B1BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1 15.4102H41.55C37.24 15.4102 35.09 20.5102 38.13 23.4902L92.28 76.5202L92.7 44.2002L63.09 15.4102H63.1Z",
    fill: "#E3E3E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.71 109.49L39.2 162.53C36.18 165.52 38.34 170.59 42.63 170.59H63.1L92.71 141.8V109.48V109.49Z",
    fill: "#B2B1BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.9 170.588H143.54C147.85 170.588 150 165.488 146.96 162.508L92.72 109.488V141.858L121.91 170.588H121.9Z",
    fill: "#E3E3E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.86 60.49L75.9 60.46L38.14 23.49C35.1 20.51 37.25 15.41 41.56 15.41H63.11L54.22 6.7C54.22 6.7 48.4 0.5 44.05 0.5H13.38C-1.21999 0.5 -4.41999 13.3 6.50001 24L75.82 92.92L92.29 76.52L75.86 60.5V60.49Z",
    fill: "url(#paint0_linear_109_22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.14 125.508L109.1 125.538L146.86 162.508C149.9 165.488 147.75 170.588 143.44 170.588H121.89L130.78 179.298C130.78 179.298 136.59 185.498 140.94 185.498H171.61C186.21 185.498 189.4 172.698 178.49 161.998L109.17 93.0781L92.7 109.478L109.13 125.498L109.14 125.508Z",
    fill: "url(#paint1_linear_109_22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.5 24C189.42 13.31 186.22 0.5 171.62 0.5H140.95C136.6 0.5 130.79 6.7 130.79 6.7L121.9 15.41H142.45C146.74 15.41 148.9 20.48 145.88 23.47L108.8 60.17L92.28 76.52L75.81 92.92L75.9 93.01L75.85 93.06L6.50001 162C-4.41999 172.69 -1.21999 185.5 13.38 185.5H44.05C48.4 185.5 54.21 179.3 54.21 179.3L63.1 170.59H42.55C38.26 170.59 36.1 165.52 39.12 162.53L76.2 125.83L92.72 109.48L109.19 93.08L109.1 92.99L109.15 92.94L178.5 24Z",
    fill: "url(#paint2_linear_109_22)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_109_22",
    x1: 186.35,
    y1: 178.15,
    x2: 21.41,
    y2: 5.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FBBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#3382C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#2B61AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#C63E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2468"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_109_22",
    x1: 173.58,
    y1: 190.728,
    x2: 8.65002,
    y2: 18.2981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FBBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#3382C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#2B61AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#C63E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2468"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_109_22",
    x1: 171.77,
    y1: 9.09001,
    x2: 11.67,
    y2: 178.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9C44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FA8747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ED5F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#862979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2468"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 185,
    height: 185,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXWalletIcon);
export default __webpack_public_path__ + "static/media/X-Wallet-Icon.a5e0c588f1c3d00371ecf9a007f42d69.svg";
export { ForwardRef as ReactComponent };